import { AdvertErrorBoundary } from 'components/advert/advert-error-boundary.js';
import { AdvertFuse } from 'components/advert/advert-fuse.js';
import { IAdvertFuseProps } from 'components/advert/types.js';
import { InterstitialHook } from 'components/interstitial/hook/interstitial-hook.js';
import { useContext } from 'react';
import { AdDomReadyContext } from 'routing/main-3-ads-ready-provider';

export const InterstitialAdvert = (props: Omit<IAdvertFuseProps, 'origin'>) => {
  const { adDisplayTrueCB, adDisplayFalseCB } = InterstitialHook();
  const { interstitialAd } = useContext(AdDomReadyContext);

  return (
    <AdvertErrorBoundary adDisplayFalseCB={adDisplayFalseCB}>
      <AdvertFuse
        {...props}
        adDisplayTrueCB={adDisplayTrueCB}
        origin={'adv-Interstitial'}
        timerDOMReady={interstitialAd.adDomReady}
        timerFuseRequest={interstitialAd.adRequest}
        timerFuseResponse={interstitialAd.adResponse}
      />
    </AdvertErrorBoundary>
  );
};
